import { createSelector } from 'reselect'
import { RootState } from 'redux/store'

const selectIsExternalAuth = createSelector(
  (state: RootState) => state.user.details.isExternalAuth,
  (isExternalAuth: boolean) => isExternalAuth
)

export default selectIsExternalAuth
